<section class="content">
    <div class="card" style="padding: 25px">
      <div class="row">
        <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
          {{title}}
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <label style="color: firebrick;">Select Date</label>
          <input type="date" [(ngModel)]="date"  class="main-border-class">
        </div>

      </div><br>

      <div class="row">
        <div class="COL-2"></div>
        <div class="col-2">
          <button (click)="getClicked()"
            style="font-size: 27px; margin-top: 14%;border-radius: 5px;background: blanchedalmond;"
            [disabled]="date == null">Get</button>
        </div>
        <div *ngIf="!is_document_available" class="col-2">
          <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
          </mat-progress-spinner>
        </div>
        <div class="col-2" *ngIf="document_file!== null">
          <button mat-button class="button-class" (click)="downloadClickedForPdf()" style="margin-top: 7px;"><i class="material-icons">
              picture_as_pdf
            </i> Download report</button>
        </div>

        <div class="col-2" *ngIf="document_file!== null" >
          <button mat-button class="button-class" (click)="downloadClickedForExcel()" style="margin-top: 7px;"><i class="material-icons">
              get_app
            </i> Download Excel</button>
        </div>
        
      </div>

    <br><br><br>
    </div>
  </section>
